import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
